const tokens = {
    borderRadius: { circle: '50%', medium: '4px' },
    borderWidth: { medium: '2px', thick: '3px', thin: '1px', xthick: '4px' },
    /** @deprecated Will be removed in `v6` - use `theme.boxShadow.*` instead. */
    boxShadow: {
        medium: '0px 1px 4px -1px rgba(5, 25, 45, 0.3)',
        thick: '0px 3px 5px -1px rgba(5, 25, 45, 0.3)',
        thin: '0px 0px 2px 0px rgba(5, 25, 45, 0.3)',
        xthick: '0px 8px 12px -4px rgba(5, 25, 45, 0.3)',
    },
    breakpoints: { large: '1480px', medium: '820px', small: '480px' },
    colors: {
        /** @deprecated Will be removed in `v6` - use greys instead. */
        beige: '#EFEBE4',
        /** @deprecated Will be removed in `v6` - use greys instead. */
        beigeLight: '#F7F3EB',
        /** @deprecated Will be removed in `v6` - use greys instead. */
        beigeMedium: '#E5E1DA',
        /** @deprecated Will be removed in `v6` - use greys instead. */
        beigeSubtle: '#FFFBF3',
        blue: '#5EB1FF',
        blue20: 'rgba(94, 177, 225, 0.2)',
        blueDark: '#257DFE',
        blueDark12: 'rgba(37, 125, 254, 0.12)',
        blueDark15: 'rgba(37, 125, 254, 0.15)',
        blueDarkText: '#0065D1',
        blueLight: '#72E5FE',
        brandFacebook: '#1778F2',
        brandGoogle: '#DB4437',
        brandLinkedIn: '#0A66C2',
        brandTwitter: '#00ACEE',
        green: '#03EF62',
        green10: 'rgba(3, 239, 98, 0.1)',
        green20: 'rgba(3, 239, 98, 0.2)',
        greenDark: '#00C74E',
        greenDarkText: '#008031',
        greenLight: '#65FF8F',
        greenLight20: 'rgba(101, 255, 143, 0.2)',
        grey: '#E8E8EE',
        grey6: 'rgba(48, 57, 105, 0.06)',
        grey10: 'rgba(48, 57, 105, 0.1)',
        grey15: 'rgba(48, 57, 105, 0.15)',
        grey20: 'rgba(48, 57, 105, 0.2)',
        grey30: 'rgba(48, 57, 105, 0.3)',
        grey60: 'rgba(48, 57, 105, 0.6)',
        greyDark: '#848492',
        greyDarkText: '#595D78',
        greyLight: '#EFEFF5',
        greyMedium: '#E1E1E8',
        greySubtle: '#F7F7FC',
        navy: '#05192D',
        navy10: 'rgba(5, 25, 45, 0.1)',
        navy70: 'rgba(5, 25, 45, 0.7)',
        navyDark: '#000820',
        navyLight: '#213147',
        navyMedium: '#13253A',
        navySubtleTextOnDark: '#9BA3AB',
        navySubtleTextOnLight: '#5D6A77',
        orange: '#FF931E',
        orange16: 'rgba(255, 147, 30, 0.2)',
        orange20: 'rgba(255, 188, 75, 0.2)',
        orangeDark: '#D87300',
        orangeDarkText: '#A85200',
        orangeLight: '#FFBC4B',
        pink: '#FF80B4',
        pinkDark: '#DC4D8B',
        pinkDark20: 'rgba(220, 77, 139, 0.2)',
        pinkDarkText: '#BF3072',
        pinkLight: '#FF95CF',
        pinkLight18: 'rgba(255, 149, 207, 0.18)',
        purple: '#7933FF',
        purple10: 'rgba(121, 51, 255, 0.1)',
        purple18: 'rgba(121, 51, 255, 0.18)',
        purple20: 'rgba(121, 51, 255, 0.2)',
        purpleDark: '#5646A5',
        purpleDarkText: '#5646A5',
        purpleLight: '#B08EFF',
        red: '#DD3400',
        red10: 'rgba(255, 73, 48, 0.1)',
        red18: 'rgba(255, 73, 48, 0.18)',
        red20: 'rgba(255, 73, 48, 0.2)',
        redDark: '#BE2705',
        redDark16: 'rgba(190, 39, 5, 0.16)',
        redDarkText: '#C01100',
        redLight: '#FF6752',
        /** @deprecated Will be removed in `v6` - use `grey15` instead */
        transparentGrey: 'rgba(48, 57, 105, 0.15)',
        /** @deprecated Will be removed in `v6` - use `grey10` instead */
        transparentGreySoft: 'rgba(48, 57, 105, 0.1)',
        /** @deprecated Will be removed in `v6` - use `grey6` instead */
        transparentGreySubtle: 'rgba(48, 57, 105, 0.06)',
        /** @deprecated Will be removed in `v6` - use `white15` instead */
        transparentWhite: 'rgba(255, 255, 255, 0.15)',
        /** @deprecated Will be removed in `v6` - use `white10` instead */
        transparentWhiteSoft: 'rgba(255, 255, 255, 0.1)',
        /** @deprecated Will be removed in `v6` - use `white6` instead */
        transparentWhiteSubtle: 'rgba(255, 255, 255, 0.06)',
        white: '#FFFFFF',
        white6: 'rgba(255, 255, 255, 0.06)',
        white10: 'rgba(255, 255, 255, 0.1)',
        white15: 'rgba(255, 255, 255, 0.15)',
        white20: 'rgba(255, 255, 255, 0.2)',
        white30: 'rgba(255, 255, 255, 0.3)',
        white60: 'rgba(255, 255, 255, 0.6)',
        yellow: '#FCCE0D',
        yellow18: 'rgba(252, 206, 13, 0.18)',
        yellowDark: '#CFA600',
        yellowDarkText: '#926904',
        yellowLight: '#FFEC3C',
        yellowLight20: 'rgba(255, 236, 60, 0.2)',
    },
    fontFamilies: {
        mono: "JetBrainsMonoNL, Menlo, Monaco, 'Courier New', monospace",
        sansSerif: 'Studio-Feixen-Sans, Arial, sans-serif',
    },
    fontSizes: {
        huge: '28px',
        large: '16px',
        medium: '14px',
        small: '12px',
        xlarge: '18px',
        xsmall: '10px',
        xxlarge: '20px',
    },
    fontWeights: { bold: 800, regular: 400 },
    letterSpacing: { default: '0px', relaxed: '1.5px', tight: '-0.5px' },
    lineHeights: { default: 1.25, relaxed: 1.5, tight: 1 },
    opacity: { high: 0.6, low: 0.1, medium: 0.4 },
    sizing: { large: '48px', medium: '36px', small: '28px' },
    spacing: {
        large: '24px',
        medium: '16px',
        small: '8px',
        xlarge: '32px',
        xsmall: '4px',
        xxlarge: '64px',
    },
    zIndex: {
        default: 1,
        dropdown: 7000,
        modal: 9000,
        overlay: 8000,
        popup: 5000,
        sticky: 100,
        toast: 10000,
    },
};
export default tokens;
